var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"Điểm danh","link":[
          { text: 'Lớp học', href: '../class-attendance' },
          { text: 'Điểm danh', href: '../class-attendance' },
        ]}})],1)]),_c('div',{staticStyle:{"overflow-x":"auto","overflow-y":"hidden"}},[_c('v-card',{staticClass:"mx-4 mb-0 pa-6",attrs:{"outlined":""}},[_c('ClassTimeTableFilter',{on:{"onFilterChanged":_vm.handleFilterChange}})],1),_c('ClassAttendance')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }